import user from './user'
import shop from './shop'
import cart from './cart'
import coupon from './coupon'
import order from './order'

export default {
    user, shop, cart, coupon, order
}
